import { useOrganization } from './useOrganization';

export const useSubscriptionDays = () => {
  const { organization } = useOrganization();

  const calculateDaysRemaining = () => {
    if (!organization?.subscription_end_date) return 0;
    
    const endDate = new Date(organization.subscription_end_date);
    const today = new Date();
    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return Math.max(0, diffDays);
  };

  return {
    daysRemaining: calculateDaysRemaining()
  };
}; 